import storesService from '../../services/storesService'

class StoresController {
  fetchStores = storesService.fetchStores
  fetchStore = storesService.fetchStore
  createStore = storesService.createStore
  patchStore = storesService.patchStore
  setStoreCalendars = storesService.setStoreCalendars
}

export default new StoresController()
 


// WEBPACK FOOTER //
// ../src/controllers/storesController/storesController.js